<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-text-neutral-primary text-base font-medium">
            {{ t('charter.refundExchangeRules') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div class="px-4 pb-4">
        <div class="bg-background-neutral-secondary rounded-2xl p-4">
          <p class="text-text-neutral-primary">
            {{ t('charter.cannotRefundExchange') }}:
          </p>
        </div>
        <FreeButton
          class="bg-button-secondary-default mt-3 flex w-full items-center space-x-2 rounded-2xl"
          size="sm"
          @click="
            hide();
            emit('onClick');
          "
        >
          <span class="text-text-content-secondary-active font-semibold"
            >{{ t('charter.readConditions') }}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M6.63 17.325a.82.82 0 0 1-.366-.548.76.76 0 0 1 .178-.617L11.691 10 6.442 3.84a.76.76 0 0 1-.178-.617.82.82 0 0 1 .366-.548 1 1 0 0 1 .333-.147 1.05 1.05 0 0 1 .723.09.9.9 0 0 1 .275.223l5.548 6.51c.16.186.246.415.246.649a1 1 0 0 1-.246.65L7.96 17.158a.9.9 0 0 1-.275.223 1.052 1.052 0 0 1-.722.09 1 1 0 0 1-.334-.147"
              clip-rule="evenodd"
            />
          </svg>
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
    FreeButton,
  } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';

  defineProps<{
    name: string;
  }>();
  const emit = defineEmits<{
    onClick: [];
  }>();

  const { t } = useI18n();
</script>

<i18n src="../locales.json" />
